// src/components/layout/SuperAdminRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LoadingSpinner } from "../ui";

export default function SuperAdminRoute({ children }) {
  const { user, isSuperAdmin, superAdminChecked, loading } = useAuth();
  if (loading || !superAdminChecked) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isSuperAdmin) return <Navigate to="/" replace />;
  return children;
}
